module.exports = __webpack_public_path__ + "img/apy-vision.bf38d345.svg";